import { Route, Routes } from 'react-router-dom';
import PresenterSession from './PresenterSession';
import SessionComplete from './SessionComplete';
import InvalidLink from './InvalidLink';

// The whole app is three screens: the live session behind a share token, the
// thank-you dead end it exits to, and a "this link isn't valid" fallback for
// anything else (including bare `/`, which nobody should reach on purpose).
export default function App() {
  return (
    <Routes>
      {/* The company segment is cosmetic — a readable slug of the company name so
          the shared URL says whose presentation it is. The token alone identifies
          the link, and links minted before the slug existed still open. */}
      <Route path="/s/:companySlug/:shareToken" element={<PresenterSession />} />
      <Route path="/s/:shareToken" element={<PresenterSession />} />
      <Route path="/session-complete" element={<SessionComplete />} />
      <Route path="*" element={<InvalidLink />} />
    </Routes>
  );
}
